<template>
    
    <div class="row">

        <div class="col-md-6">
            <!-- Form Input -->
            <div class="form-group">
                <label for="asignatura_id">Asignatura</label>
                <select name="asignatura_id" id="asignatura_id" v-model="asignatura_id" class="form-control" placeholder="Asignatura" required @change="SeleccionarAsignatura">
                    <option v-for="asignatura in asignaturas" :value="asignatura.id" :key="'asignatura-' + asignatura.id">{{ asignatura.nombre }}</option>
                </select>
            </div>
        </div>

        <div class="col-md-6">
            <!-- Form Input -->
            <div class="form-group">
                <label for="sigla">Sigla</label>
                <input type="text" name="sigla" v-model="sigla" class="form-control" maxlength="191" placeholder="Sigla" disabled>
            </div>
        </div>
        
    </div>

</template>

<script>
    export default {
        data() {
            return {
                asignatura_id: null,
                asignaturas: [],
                sigla: null,
            }
        },
        props: {
            tipo_programa_slug: {required: false, default: ""},
            prop_asignatura_id: {required: false, default: 0},
        },
        mounted() {
            if(this.prop_asignatura_id) {
                this.asignatura_id = this.prop_asignatura_id;
            }

            this.CargarAsignaturas();
        },
        methods: {
            CargarAsignaturas() {
                const self = this;

                // Cargamos URL
                axios.get('/data/asignaturas/' + self.tipo_programa_slug)
                    .then(response => {
                        self.asignaturas = response.data.asignaturas;

                        if(self.asignatura_id)
                            self.SeleccionarAsignatura();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            SeleccionarAsignatura() {
                const self = this;
                const asignaturas = this.asignaturas.filter(asignatura => asignatura.id == self.asignatura_id);
                
                if(asignaturas.length > 0)
                    self.sigla = asignaturas[0].sigla;
            }
        }
    }
</script>